import axios from 'axios';

export default {
  url: function(){
    return process.env.VUE_APP_API_URL;
  },
  checkExecutionErrorVue: function (vueSelf, response, frontMethod) {
    if (response['Response']['ExecutionError']['ExecutionErrorCode'] === 0) {
      return true;
    }

    let err = '';
    if (response['Response']['ExecutionError']['ExecutionErrorMessage'] != undefined) {
      err = response['Response']['ExecutionError']['ExecutionErrorMessage'];
    } else {
      err = JSON.stringify(response);
    }

    // vueSelf.$store.commit('showModal');
    // vueSelf.$store.commit('setContent',err);
    return false;
  },
  checkErrorCodeVue: function (response, vueSelf, frontMethod) {
    let errorMsg = 'Ошибка, <hr/>JS - ' + frontMethod + '<hr/>' + JSON.stringify(response);
    if (response === null) {
      // vueSelf.$store.commit('showModal');
      // vueSelf.$store.commit('setContent', errorMsg);
      // vueSelf.$store.commit('userCanCloseModal');
      return {result: false, reload: false};
    }
    if (response.Error['ErrorCode'] < 0) {
      // vueSelf.$store.commit('showModal');
      // vueSelf.$store.commit('setContent', errorMsg);
      // vueSelf.$store.commit('userCanCloseModal');
      return {result: false, reload: false};
    }
    if (response.Error['ErrorCode'] > 0) {
      return {result: true, reload: true};
    }
    if (response.Error['ErrorCode'] === 0) {
      // vueSelf.$store.commit('userCanCloseModal');
      let responeResult = true;
      if (response.hasOwnProperty('Response')) {
        responeResult = this.checkExecutionErrorVue(vueSelf, response, frontMethod);
      }
      if (responeResult) {
        return {result: true, reload: false};
      } else {
        return {result: false, reload: false};
      }
    }
    // vueSelf.$store.commit('setContent', errorMsg);
    return {result: false, reload: false}
  },
  SendRequest: function (sendData, vueSelf, debugMarker, showModal) {
    return new Promise((resolve,reject) => {
      let self = this;
      if (showModal) {
        vueSelf.$store.commit('setContent', 'Отправкa запроса');
        vueSelf.$store.commit('userCanNotCloseModal');
        vueSelf.$store.commit('showModal');
      }
      sendData['Device_guid'] = localStorage.getItem('Device_guid');
      sendData['Staff_guid'] = localStorage.getItem('Staff_guid');
      sendData['cache'] = localStorage.getItem('cache');
      axios({
        method: 'post',
        url: this.url(),
        data: sendData,
        responseType: 'json',
        headers: {'Content-type': 'application/json'}
      }).then(function (response) {
        // debugger;
        let checkResult = self.checkErrorCodeVue(response.data, vueSelf, 'getGuid/' + debugMarker);
        if (checkResult.result) {
          if (checkResult.reload) {
            // vueSelf.$store.commit('setContent', 'Отправкa повторного запроса');
            const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
            wait(500).then(()=>{
              self.SendRequest(sendData, vueSelf, debugMarker, showModal)
                .then((res)=>{resolve(res)})
                .catch((res)=>{reject(res)});
            });
          } else {
            self.GetRequestResult(response.data['RequestID'],  vueSelf,debugMarker, showModal)
              .then((res)=>{resolve(res)})
              .catch((res)=>{reject(res)});
          }
        } else {
            reject(response.data);
        }
      }).catch(error => {
        reject(error);
      });
    });
  },
  GetRequestResult: function (ExecuteGUID, vueSelf,debugMarker, showModal) {
    return new Promise((resolve,reject) => {
      let self = this;
      let sendData = {
        ExecuteGUID: ExecuteGUID,
        Device_guid: localStorage.getItem('Device_guid'),
        Staff_guid: localStorage.getItem('Staff_guid'),
        cache: localStorage.getItem('cache'),
        action: 'iks_GetQuery'
      };

      axios({
        method: 'post',
        url: this.url(),
        data: sendData,
        responseType: 'json',
        headers: {'Content-type': 'application/json'}
      }).then(function (response) {
        let checkResult = self.checkErrorCodeVue(response.data, vueSelf, 'getResultSaveForm');
        if (checkResult.result){
          if (checkResult.reload) {
            // vueSelf.$store.commit('setContent', 'Отправкa повторного запроса');
            const wait = ms => new Promise(resolve => setTimeout(resolve, ms));
            wait(500).then(()=>{
              self.GetRequestResult(ExecuteGUID, vueSelf,debugMarker, showModal)
                .then((res)=>{resolve(res);})
                .catch((res)=>{reject(res)});
            });
          } else {
            resolve(response.data['Response']['ExecutionResult']);
          }
        } else {
          reject(response.data);
        }
      }).catch((resp)=>{
        if (resp.data != undefined) {
          reject(resp.data);
        } else {
          reject(resp);
        }
      });
    });
  },
  singleRequest: function(sendData) {
    return new Promise((resolve, reject) => {
      axios({
        method:'post',
        url:this.url(),
        data:sendData
      }).then((resp)=>{
        try {
          if (resp.data.Response.ExecutionResult !== undefined) {
            resolve(resp.data.Response.ExecutionResult);
          } else {
            reject(resp.data);
          }
        } catch (resp) {
          reject(resp.data);
        }
      }).catch((resp)=>{
        if (resp.data != undefined) {
          reject(resp.data);
        } else {
          reject(resp);
        }
      });
    });
  },
  displayErrors: function (response, vueSelf) {
    vueSelf.$store.commit('showModal');
    vueSelf.$store.commit('userCanCloseModal');
    try {
      vueSelf.$store.commit('setContent', (response.Response.ExecutionError.ExecutionErrorMessage));
    } catch (e) {
      vueSelf.$store.commit('setContent', JSON.stringify(response));
    }
  },
  checkVersion: function (debugMarker) {
 return new Promise((resolve) => {
  resolve(true);
  // console.log('checkVersion start')
      // this.singleRequest({
      //   action: 'checkVersion'
      // }).then((res) => {
      //   if (localStorage.getItem('cache') === null) {
      //     localStorage.setItem('cache', res.cache)
      //   } else if (localStorage.getItem(('cache')) != res.cache) {
      //     localStorage.setItem('cache', res.cache)
      //     // console.log('before reload');
      //     document.location.reload();
      //     // console.log('after reload');
      //     reject(res);
      //   }
      //   // console.log('checkVersion then')
      //   resolve(res);
      // })
      // .catch((res) => {
      //   // console.log('checkVersion cath')
      //   reject(res);
      // });
    });
  },
}
